import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const GetRevenueResponseDtoSchema = z.object({
  revenue: z.object({
    amountUsd: z.number().nullable().optional(),
    changePct: z.number().nullable(),
  }),
  sparkline: z.object({
    granularity: z.string(),
    points: z.array(
      z.object({
        start: z.string(),
        end: z.string(),
        value: z.number().nullable(),
      })
    ),
  }),
});

const _GetRevenueRequestDtoSchema = z.object({
  from: z.string(),
  to: z.string(),
  facilitiesIds: z.array(z.number()).optional(),
});

export type GetRevenueRequestDto = z.infer<typeof _GetRevenueRequestDtoSchema>;
export type GetRevenueResponseDto = z.infer<typeof GetRevenueResponseDtoSchema>;

export const getRevenue = (
  params: GetRevenueRequestDto,
  config?: AxiosRequestConfig<GetRevenueRequestDto>
) => {
  return api
    .get('/facilities/revenue', { params, ...config })
    .then(responseContract(GetRevenueResponseDtoSchema));
};
